import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const OPPORTUNITY_COLOR = '#FBBF24';

export const OpportunityNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={OPPORTUNITY_COLOR} icon={'\u2728'} selected={selected} />;
};

export default OpportunityNode;
